/**
 * Translation keys used by the reservation feature.
 *
 * Collected in one place so the whole set can be handed to localisation at once. Keys are
 * resolved remotely (i18next-http-backend); until they are published, i18next renders the key
 * itself, which is visible but non-breaking.
 *
 * The inline block has its own keys rather than reusing `PH.CARD_VERIFICATION.*`: those belong to
 * the separate `kyc_card_verification` feature and would be retired with it. Copy should match the
 * design; the values can be identical without the dependency being.
 */
export const RESERVATION_KEYS = {
  /** Inline block in the deposit form — five states. */
  blockCheckingTitle: 'PH.RESERVATION.CARD_BLOCK.CHECKING.TITLE',
  blockCheckingBody: 'PH.RESERVATION.CARD_BLOCK.CHECKING.BODY',
  blockConfirmTitle: 'PH.RESERVATION.CARD_BLOCK.CONFIRM.TITLE',
  blockConfirmBody: 'PH.RESERVATION.CARD_BLOCK.CONFIRM.BODY',
  blockPendingTitle: 'PH.RESERVATION.CARD_BLOCK.PENDING.TITLE',
  blockPendingBody: 'PH.RESERVATION.CARD_BLOCK.PENDING.BODY',
  blockVerifiedTitle: 'PH.RESERVATION.CARD_BLOCK.VERIFIED.TITLE',
  blockVerifiedBody: 'PH.RESERVATION.CARD_BLOCK.VERIFIED.BODY',
  blockFailedTitle: 'PH.RESERVATION.CARD_BLOCK.FAILED.TITLE',
  blockFailedBody: 'PH.RESERVATION.CARD_BLOCK.FAILED.BODY',

  /** «Зарезервувати 250 USD» — submit places a hold instead of depositing. */
  submitReserve: 'PH.RESERVATION.BUTTON.RESERVE_AMOUNT',
  /** «Поповнити 250 USD» — card already verified, normal deposit. Existing shared key. */
  submitDeposit: 'PH.BUTTON.DEPOSIT_AMOUNT',

  /** Account not KYC-verified: «Кошти зарезервовано на 168 годин». */
  kycTitle: 'PH.RESERVATION.KYC.TITLE',
  kycBody: 'PH.RESERVATION.KYC.BODY',
  kycAction: 'PH.RESERVATION.KYC.ACTION',

  /** Hold placed, card proof outstanding: «Кошти зарезервовано». */
  reservedTitle: 'PH.RESERVATION.RESERVED.TITLE',
  reservedBody: 'PH.RESERVATION.RESERVED.BODY',

  /** «Картку успішно верифіковано». */
  successTitle: 'PH.RESERVATION.SUCCESS.TITLE',
  successBody: 'PH.RESERVATION.SUCCESS.BODY',
  /** «Повернутися до гри» — leaves the widget. */
  successAction: 'PH.RESERVATION.SUCCESS.ACTION',

  /**
   * Hold ran out, funds returned. No Figma frame exists for this outcome — it is a static page
   * agreed as a substitute, so the copy lives entirely in these keys.
   */
  expiredTitle: 'PH.RESERVATION.EXPIRED.TITLE',
  expiredBody: 'PH.RESERVATION.EXPIRED.BODY',
  expiredAction: 'PH.RESERVATION.EXPIRED.ACTION',
} as const;
